module.exports = __webpack_public_path__ + "static/media/skype.3859d737.svg";